export const getErrorMessage = (name, formik) => {
    const isFormFieldValid = (nam) => !!(Object.keys(formik.touched).length && formik.errors[nam]);
    if (isFormFieldValid(name)) {
        return formik.errors[name];
    }
    return undefined;
};
